import { render } from "./AnswerOnMessage.vue?vue&type=template&id=33fcfee6&scoped=true"
import script from "./AnswerOnMessage.vue?vue&type=script&lang=js"
export * from "./AnswerOnMessage.vue?vue&type=script&lang=js"

import "./AnswerOnMessage.vue?vue&type=style&index=0&id=33fcfee6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fcfee6"]])

export default __exports__